import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-169">
      <div className="max-w-3xl mx-auto" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6 leading-tight" data-id="element-172">
            Si querés bajar de peso y comer mejor…{' '}
            <span className="text-red-600 underline decoration-yellow-400 decoration-4 underline-offset-4" data-id="element-173">
              necesitás leer esto
            </span>
          </h2>
          <p className="text-xl text-gray-700 font-medium" data-id="element-174">
            ¿Cuántas veces intentaste cambiar tu alimentación… pero terminaste
            abandonando a los pocos días?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100" data-id="element-175">
          <p className="text-xl font-bold text-center mb-6 text-gray-800" data-id="element-176">
            No es falta de voluntad. Nunca lo fue.
          </p>
          <p className="text-lg text-center mb-6 text-gray-600" data-id="element-177">Es que:</p>

          <ul className="space-y-4 mb-8 max-w-md mx-auto" data-id="element-178">
            {['no sabés qué comer', 'no tenés un plan claro', 'no querés vivir a dieta', 'y te cansás de pensar todos los días qué cocinar'].map((item, index) => <li key={index} className="flex items-center gap-3 text-lg font-medium text-gray-700" data-id="element-179">
                <span className="text-red-500 text-2xl" data-id="element-180">❌</span>
                {item}
              </li>)}
          </ul>

          <div className="text-center" data-id="element-181">
            <p className="text-xl font-bold text-gray-900 mb-4" data-id="element-182">
              Y entonces pasa lo mismo de siempre…
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 text-lg font-bold text-gray-600" data-id="element-183">
              <span data-id="element-184">👉 volvés a lo rápido</span>
              <span className="hidden sm:inline" data-id="element-185">|</span>
              <span data-id="element-186">👉 a lo fácil</span>
              <span className="hidden sm:inline" data-id="element-187">|</span>
              <span data-id="element-188">👉 a lo que ya sabés que no te hace bien</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}